import { getJackpotCurrenciesGameIds } from '../../services/stores/jackpotsStore'
import { usePlayerStore } from '../../services/store'

export const useJackpotGameIconTout = () => {
  const jackpotCurrenciesGameIds = getJackpotCurrenciesGameIds()
  const playerStore = usePlayerStore()
  const playerActiveCurrencyData = playerStore.use.playerActiveCurrencyData()

  const getShowJackpotIcon = gameId => {
    const jackpotGame = jackpotCurrenciesGameIds && jackpotCurrenciesGameIds[gameId]

    if (jackpotGame) {
      return (
        jackpotGame.currencies.includes(playerActiveCurrencyData.currencyName) || jackpotGame.currencies.includes('DIA')
      )
    } else {
      return false
    }
  }

  return { getShowJackpotIcon }
}
